import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { SSR_OPTIONS } from "src/Modules/Flights/constants/JourneyDetails";
import { useSSRContext } from "../../context/SSRContext";

type PassengerDeclarationProps = {
  extraInfo?: ReactNode;
};

export default function PassengerDeclaration({ extraInfo }: PassengerDeclarationProps) {
  const { t } = useTranslation();
  const { cursor } = useSSRContext();
  const ssrOption = SSR_OPTIONS.find((option) => option.value === cursor.ssrType);

  return (
    <div className="flex w-full items-center justify-between gap-4 flex-wrap">
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="text-font-default truncate text-lg font-semibold">{t("Flights.details.ssr.availableOptions")}</span>
        {ssrOption && (
          <span className="text-font-subtle truncate text-xs font-normal">
            {t("Flights.details.ssr.selectYourOptions", { type: ssrOption.label.toLowerCase() })}
          </span>
        )}
      </div>
      {extraInfo && <div className="text-font-success flex shrink-0 items-center gap-1 text-xs font-semibold">{extraInfo}</div>}
    </div>
  );
}
